function countdown_timer(targetID, [day, month, year, hour, minute, ampm], [banner_text, locales_day, locales_hour, locales_min, locales_sec], styled, delayOnClass, double_up_numbers) {

  const countdown_container = document.getElementById(targetID);

  var end = new Date(`${month}/${day}/${year} ${hour}:${minute} ${ampm}`);

  var _second = 1000;
  var _minute = _second * 60;
  var _hour = _minute * 60;
  var _day = _hour * 24;
  var timer;

  var banner_text = banner_text;
  var sale_ends_text = "";
  
  if(banner_text.includes("|")){
    banner_text = banner_text.split("|");
    sale_ends_text = "<span class='sale_ends_container'><span class='sale_ends_text'>" + banner_text[1] + "</span></span>";
    banner_text = banner_text[0];
  }
  
  if(banner_text.includes("-")){
    var banner_text_split = banner_text.split("-");
    
    for(var i = 0; i < banner_text_split.length; i++){
      if(i==0){
        banner_text = banner_text_split[0] + "<span class='small_txt_area'>";
      }
      else if(i == banner_text_split.length) {
        banner_text = banner_text + banner_text_split[i] + "-"
      }
      else {
        banner_text = banner_text + banner_text_split[i] + "</span>";
      }
    }

  }


  // If Ended, instantly hide
  if ((end - new Date()) < 0) {
    if(countdown_container.closest("[data-time-expired-remove]")) {
      countdown_container.closest("[data-time-expired-remove]").remove();
    }
    countdown_container.remove();
  }
  else {

    if(styled == true) {
      countdown_container.classList += "countdown_banner_styled";
      countdown_container.innerHTML += `
        <div class="countdown_container">
          <div class="countdown_container_inner">
            <h3 class="countdown_header">${banner_text}</h3>
            <div class="countdown_counter">${sale_ends_text}
              <div class="countdown_counter_item day"><span class="number">${Math.floor((end - new Date()) / _day)}</span><label>${locales_day}</label></div>
              <div class="countdown_counter_item hour"><span class="number">${Math.floor(((end - new Date()) % _day) / _hour)}</span><label>${locales_hour}</label></div>
              <div class="countdown_counter_item minute"><span class="number">${Math.floor(((end - new Date()) % _hour) / _minute)}</span><label>${locales_min}</label></div>
              <div class="countdown_counter_item second"><span class="number">${Math.floor(((end - new Date()) % _minute) / _second)}</span><label>${locales_sec}</label></div>
            </div>
          </div>
        </div>
      `;
    }
    else if(double_up_numbers == true) {
      countdown_container.classList += "countdown_blank countdown_doubleUpNumbers";
      countdown_container.innerHTML += `
        <div class="countdown_counter">
          <div class="countdown_counter_item day"><span class="number_container"><span class="number">${Math.floor((end - new Date()) / _day)}</span><span class="number">${Math.floor((end - new Date()) / _day)}</span></span><label>${locales_day}</label></div>
          <div class="countdown_counter_item hour"><span class="number_container"><span class="number">${Math.floor(((end - new Date()) % _day) / _hour)}</span><span class="number">${Math.floor(((end - new Date()) % _day) / _hour)}</span></span><label>${locales_hour}</label></div>
          <div class="countdown_counter_item minute"><span class="number_container"><span class="number">${Math.floor(((end - new Date()) % _hour) / _minute)}</span><span class="number">${Math.floor(((end - new Date()) % _hour) / _minute)}</span></span><label>${locales_min}</label></div>
          <div class="countdown_counter_item second"><span class="number_container"><span class="number">${Math.floor(((end - new Date()) % _minute) / _second)}</span><span class="number">${Math.floor(((end - new Date()) % _minute) / _second)}</span></span><label>${locales_sec}</label></div>
        </div>
      `;
    }
    else {
      countdown_container.classList += "countdown_blank";
      countdown_container.innerHTML += `
        <div class="countdown_counter">
          <div class="countdown_counter_item day"><span class="number">${Math.floor((end - new Date()) / _day)}</span><label>${locales_day}</label></div>
          <div class="countdown_counter_item hour"><span class="number">${Math.floor(((end - new Date()) % _day) / _hour)}</span><label>${locales_hour}</label></div>
          <div class="countdown_counter_item minute"><span class="number">${Math.floor(((end - new Date()) % _hour) / _minute)}</span><label>${locales_min}</label></div>
          <div class="countdown_counter_item second"><span class="number">${Math.floor(((end - new Date()) % _minute) / _second)}</span><label>${locales_sec}</label></div>
        </div>
      `;
    }


    const countdown_counter = document.querySelector("#" + targetID + " .countdown_counter");
    
    const countdown_counter_day = countdown_counter.querySelectorAll("#" + targetID + " .countdown_counter .day .number");
    const countdown_counter_hour = countdown_counter.querySelectorAll("#" + targetID + " .countdown_counter .hour .number");
    const countdown_counter_minute = countdown_counter.querySelectorAll("#" + targetID + " .countdown_counter .minute .number");
    const countdown_counter_second = countdown_counter.querySelectorAll("#" + targetID + " .countdown_counter .second .number");

    function showRemaining() {

        var now = new Date();
        var distance = end - now;

        if (distance < 0) {
            clearInterval(timer);
            return;
        }

        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        if(countdown_counter_day[0].innerText != days){
          if(countdown_counter_day.length == 1){
            countdown_counter_day[0].innerText = days; 
          }
          else {
            setTimeout(()=> { countdown_counter_day.forEach(time => time.innerText = days) }, 210);
          }
          if(delayOnClass){
            countdown_counter_day[0].parentElement.classList.add("updated");
            setTimeout(()=>{
              countdown_counter_day[0].parentElement.classList.remove("updated");
            }, 50);
          }
        }
        if(countdown_counter_hour[0].innerText != hours){
          if(countdown_counter_hour.length == 1){
            countdown_counter_hour[0].innerText = hours; 
          }
          else {
            setTimeout(()=> { countdown_counter_hour.forEach(time => time.innerText = hours) }, 210);
          }
          if(delayOnClass){
            countdown_counter_hour[0].parentElement.classList.add("updated");
            setTimeout(()=>{
              countdown_counter_hour[0].parentElement.classList.remove("updated");
            }, 50);
          }
        }
        if(countdown_counter_minute[0].innerText != minutes){
          if(countdown_counter_minute.length == 1){
            countdown_counter_minute[0].innerText = minutes; 
          }
          else {
            setTimeout(()=> { countdown_counter_minute.forEach(time => time.innerText = minutes) }, 210);
          }
          if(delayOnClass){
            countdown_counter_minute[0].parentElement.classList.add("updated");
            setTimeout(()=>{
              countdown_counter_minute[0].parentElement.classList.remove("updated");
            }, 50);
          }
        }
        if(countdown_counter_second[0].innerText != seconds){
          if(countdown_counter_second.length == 1){
            countdown_counter_second[0].innerText = seconds; 
          }
          else {
            setTimeout(()=> { countdown_counter_second.forEach(time => time.innerText = seconds) }, 210);
          }
          if(delayOnClass){
            countdown_counter_second[0].parentElement.classList.add("updated");
            setTimeout(()=>{
              countdown_counter_second[0].parentElement.classList.remove("updated");
            }, 50);
          }
        }

    }

//    timer = setInterval(showRemaining, 1000);
    timer = setInterval(showRemaining, 500);
  }

};